/* eslint-disable */
import React, { useEffect, useState } from 'react';

import MenuItem from '@mui/material/MenuItem';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import {
  ButtonStyled,
  DateInputStyled,
  FrequencyInputStyled,
  InputBoxStyled,
  ModalBoxStyled,
  PeriodsInputStyled,
  RootStyled,
} from './index.styles';

const headings = ['Por quantidade de períodos', 'Por data'];
const frequencyOptions = [
  { value: 'weekly', label: 'Semanal' },
  { value: 'biweekly', label: 'Quinzenal' },
  { value: 'monthly', label: 'Mensal' },
  { value: 'quarterly', label: 'Trimestral' },
  { value: 'annualy', label: 'Anual' },
];

function NewSchedule(props) {
  const [tabValue, setTabValue] = useState(0);

  const {
    open,
    onClose,
    disableInputs,
    frequency,
    handleFrequency,
    periods,
    setPeriods,
    percentageValues,
    initialDate,
    setInitialDate,
    finalDate,
    setFinalDate,
    saveSchedule,
    clearPercentageValues,
  } = props;

  const changeTab = (_e, newValue) => {
    clearPercentageValues();
    setTabValue(newValue);
  };

  function countPeriodsBetweenDates() {
    const MILISECONDS_IN_A_WEEK = 604800000;
    const MILISECONDS_IN_15_DAYS = 1296000000;
    const MILISECONDS_IN_A_MONTH = 2592000000;
    const MILISECONDS_IN_A_TRIMESTER = 7776000000;
    const MILISECONDS_IN_A_YEAR = 31536000000;

    const start = new Date(initialDate.split('/').join('-'));
    const end = new Date(finalDate.split('/').join('-'));

    const differenceInMiliseconds = end - start;

    if (differenceInMiliseconds === 0) {
      setPeriods(1);
      return;
    }

    let amountOfPeriods;

    switch (frequency) {
      case 'weekly':
        amountOfPeriods = Math.ceil(
          differenceInMiliseconds / MILISECONDS_IN_A_WEEK
        );
        break;
      case 'biweekly':
        amountOfPeriods = Math.ceil(
          differenceInMiliseconds / MILISECONDS_IN_15_DAYS
        );
        break;
      case 'monthly':
        amountOfPeriods = Math.ceil(
          differenceInMiliseconds / MILISECONDS_IN_A_MONTH
        );
        break;
      case 'quarterly':
        amountOfPeriods = Math.ceil(
          differenceInMiliseconds / MILISECONDS_IN_A_TRIMESTER
        );
        break;
      default:
        amountOfPeriods = Math.ceil(
          differenceInMiliseconds / MILISECONDS_IN_A_YEAR
        );
        break;
    }
    setPeriods(amountOfPeriods);
  }

  useEffect(() => {
    countPeriodsBetweenDates();
  }, [finalDate]);

  return (
    <RootStyled open={open} onClose={onClose}>
      <ModalBoxStyled>
        <Tabs value={tabValue} onChange={changeTab} variant="fullWidth">
          {headings.map((title) => (
            <Tab label={title} key={title} />
          ))}
        </Tabs>
        <InputBoxStyled>
          <FrequencyInputStyled
            disabled={disableInputs}
            id="timeline-frequency"
            label="Periodicidade"
            variant="outlined"
            value={frequency}
            onChange={handleFrequency}
            select
            slotProps={{
              select: {
                MenuProps: {
                  anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                  getContentAnchorEl: null,
                },
              },
            }}
          >
            {frequencyOptions.map((option) => (
              <MenuItem
                style={{ zIndex: 100 }}
                key={option.value}
                value={option.value}
              >
                {option.label}
              </MenuItem>
            ))}
          </FrequencyInputStyled>
          {tabValue === 0 && (
            <PeriodsInputStyled
              disabled={disableInputs}
              id="timeline-periods"
              label="Qtd de períodos"
              variant="outlined"
              type="number"
              value={periods}
              error={Number(periods) <= 0}
              FormHelperTextProps={{ style: { position: 'absolute', top: 50 } }}
              helperText={Number(periods) <= 0 && 'Deve ser maior do que zero'}
              onChange={(e) => {
                let { value } = e.target;
                if (value > 60) {
                  value = 60;
                }
                setPeriods(value);
                percentageValues.forEach((scheduleItems) => {
                  if (scheduleItems.length < value) {
                    for (let i = scheduleItems.length; i < value; i += 1) {
                      scheduleItems.push(0);
                    }
                  }
                });
              }}
            />
          )}
          <DateInputStyled
            id="timeline-initial-date"
            disabled={disableInputs}
            label="Data inicial do cronograma"
            variant="outlined"
            type="date"
            value={initialDate.split('/').join('-')}
            slotProps={{
              inputLabel: { shrink: true },
            }}
            inputProps={{ max: '9999-12-31' }}
            onChange={(e) =>
              setInitialDate(e.target.value.split('-').join('/'))
            }
          />
          {tabValue === 1 && (
            <DateInputStyled
              id="timeline-final-date"
              disabled={disableInputs}
              label="Data final do cronograma"
              variant="outlined"
              type="date"
              value={finalDate.split('/').join('-')}
              slotProps={{
                inputLabel: { shrink: true },
              }}
              inputProps={{
                max: '9999-12-31',
                min: initialDate.split('/').join('-'),
              }}
              onChange={(e) =>
                setFinalDate(e.target.value.split('-').join('/'))
              }
            />
          )}
        </InputBoxStyled>
        <ButtonStyled
          onClick={saveSchedule}
          disabled={
            tabValue === 0
              ? !frequency || !periods || !initialDate || Number(periods) <= 0
              : !frequency || !periods || !initialDate || !finalDate
          }
        >
          Salvar Cronograma
        </ButtonStyled>
      </ModalBoxStyled>
    </RootStyled>
  );
}

export default NewSchedule;
